import FormControlLabel from '@mui/material/FormControlLabel';
import Switch, { type SwitchProps } from '@mui/material/Switch';
import type { Control, FieldValues, Path } from 'react-hook-form';
import { Controller } from 'react-hook-form';

interface ControlledSwitchProps<T extends FieldValues> extends Omit<SwitchProps, 'onChange'> {
  id?: string;
  name: Path<T>;
  label?: string;
  control: Control<T>;
  handleOnChange?: (checked: boolean) => void;
}

export const ControlledSwitch = <T extends FieldValues>({
  id,
  name,
  control,
  handleOnChange,
  label,
  ...props
}: ControlledSwitchProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <FormControlLabel
          id={id}
          label={label}
          control={
            <Switch
              color="info"
              checked={value}
              onChange={(event, checked) => {
                onChange(checked);
                handleOnChange?.(checked);
              }}
              {...props}
            />
          }
        />
      )}
    />
  );
};
